/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcommerceUserApiUpdateReq
 */
export interface EcommerceUserApiUpdateReq {
    /**
     * 平台侧企业/店铺账号标识。
     * @type {string}
     * @memberof EcommerceUserApiUpdateReq
     */
    externalAccountId: string;
    /**
     * 新Access Key，为空表示保留原值。
     * @type {string}
     * @memberof EcommerceUserApiUpdateReq
     */
    credentialKey?: string;
    /**
     * 新Secret Key，为空表示保留原值。
     * @type {string}
     * @memberof EcommerceUserApiUpdateReq
     */
    credentialSecret?: string;
    /**
     * 凭证有效期，可选；为空或勾选无限期时不判断过期。
     * @type {string}
     * @memberof EcommerceUserApiUpdateReq
     */
    credentialExpireTime?: string;
    /**
     * 是否无限期；为true时清空已有到期时间。
     * @type {boolean}
     * @memberof EcommerceUserApiUpdateReq
     */
    credentialExpireUnlimited?: boolean;
}

/**
 * Check if a given object implements the EcommerceUserApiUpdateReq interface.
 */
export function instanceOfEcommerceUserApiUpdateReq(value: object): value is EcommerceUserApiUpdateReq {
    if (!('externalAccountId' in value) || value['externalAccountId'] === undefined) return false;
    return true;
}

export function EcommerceUserApiUpdateReqFromJSON(json: any): EcommerceUserApiUpdateReq {
    return EcommerceUserApiUpdateReqFromJSONTyped(json, false);
}

export function EcommerceUserApiUpdateReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceUserApiUpdateReq {
    if (json == null) {
        return json;
    }
    return {
        
        'externalAccountId': json['externalAccountId'],
        'credentialKey': json['credentialKey'] == null ? undefined : json['credentialKey'],
        'credentialSecret': json['credentialSecret'] == null ? undefined : json['credentialSecret'],
        'credentialExpireTime': json['credentialExpireTime'] == null ? undefined : json['credentialExpireTime'],
        'credentialExpireUnlimited': json['credentialExpireUnlimited'] == null ? undefined : json['credentialExpireUnlimited'],
    };
}

export function EcommerceUserApiUpdateReqToJSON(json: any): EcommerceUserApiUpdateReq {
    return EcommerceUserApiUpdateReqToJSONTyped(json, false);
}

export function EcommerceUserApiUpdateReqToJSONTyped(value?: EcommerceUserApiUpdateReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalAccountId': value['externalAccountId'],
        'credentialKey': value['credentialKey'],
        'credentialSecret': value['credentialSecret'],
        'credentialExpireTime': value['credentialExpireTime'],
        'credentialExpireUnlimited': value['credentialExpireUnlimited'],
    };
}

